import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import RequestTable_vue_vue_type_script_setup_true_lang_default from "./RequestTable.vue.script.js";
/* empty css                           */
//#region src/v2/blocks/request-block/components/RequestTable.vue
var RequestTable_default = /*#__PURE__*/ _plugin_vue_export_helper_default(RequestTable_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-bb7a09e9"]]);
//#endregion
export { RequestTable_default as default };

//# sourceMappingURL=RequestTable.vue.js.map